export class VisibilityObserver {

    public elements:JQuery|null=null;
    public io:IntersectionObserver|null=null;
    private threshold:Array<number> = [];
    public static singleton:VisibilityObserver;

    constructor() {
        if (VisibilityObserver.singleton) return VisibilityObserver.singleton;
        this.elements = $('[class*="paragraph-"],[class*="observe-"]');
        this.elements.each((key,element)=>{
            this.addIfUnique(this.cssVar(element, "observer-threshold"));
        });
        this.addIfUnique(1.0);
        $(document).ready(()=>{
            this.addObserver();
        });
    }

    private cssVar(element:any,name:string,value?:any) {
        if(name[0]!='-') name = '--'+name; //allow passing with or without --
        if(value) element.style.setProperty(name, value);
        value = getComputedStyle(element).getPropertyValue(name);
        if(value == "") {
            return false;
        } else {
            return value;
        }
    }

    private addIfUnique(value:number) {
        if(!value) return;
        for(var i = 0; i < this.threshold.length; i++) {
            if(this.threshold[i] == value) return;
        }

        this.threshold.push(value);
        this.threshold.sort();
    }

    private addObserver() {
        this.io = new IntersectionObserver ( (entries) => {
                entries.forEach((entry) => {
                    let cssVar = parseFloat(this.cssVar(entry.target,"observer-threshold")? this.cssVar(entry.target,"observer-threshold") : 1);

                    if(entry.isIntersecting && entry.intersectionRatio >= cssVar) {
                        entry.target.classList.add('see');
                        entry.target.classList.add('seen');
                        $(entry.target).trigger('observer.in');
                    } else {
                        entry.target.classList.remove('see');
                        $(entry.target).trigger('observer.out');
                    }
                });
            },
            {
                threshold: this.threshold
            }
        );

        this.elements?.each((key,element)=>{
            this.io?.observe(element);
        });
    }
}
export {};